export default "__VITE_ASSET__CKO6NaFU__"